import { render, staticRenderFns } from "./Miscarriage.vue?vue&type=template&id=52af61aa&scoped=true&"
import script from "./Miscarriage.vue?vue&type=script&lang=js&"
export * from "./Miscarriage.vue?vue&type=script&lang=js&"
import style0 from "./Miscarriage.vue?vue&type=style&index=0&id=52af61aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af61aa",
  null
  
)

export default component.exports